<template>
  <v-card flat color="transparent">
    <v-img
      contain
      :height="size"
      :width="size"
      :max-height="size"
      :max-width="size"
      src="img/Loading-Blue.gif"
    ></v-img>
  </v-card>
</template>
<script setup lang="ts">
const { size = 150 } = defineProps<{ size?: number }>()
</script>
